import { getDynamicToken } from './authUtils';

export const updateClaimStatus = async (status) => {
    try {
        const claim_num = localStorage.getItem('ref_num');
        console.log(status)
        if (!claim_num) {
            console.error('No claim number found in localStorage');
            return { success: false, message: 'Claim number not found' };
        }

        const dynamicToken = await getDynamicToken();
        
        const payload = {
            claim_num,
            status
        };

        //! Add timestamp if status is FIRST_IMAGE_CLICKED
        if (status === 'FIRST_IMAGE_CLICKED') {
            payload.first_image_click_timestamp = new Date().toISOString();
        }

        const response = await fetch(`${import.meta.env.VITE_API_URL}/update-status`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${dynamicToken}`
            },
            body: JSON.stringify(payload)
        });

        const data = await response.json();
        
        if (!response.ok) {
            console.error('Failed to update claim status:', data);
            return { success: false, ...data };
        }

        return data;
    } catch (error) {
        console.error('Error updating claim status:', error);
        return { success: false, message: error.message };
    }
};